import { render, staticRenderFns } from "./bundle_package.vue?vue&type=template&id=7ed9fd24&scoped=true&"
import script from "./bundle_package.vue?vue&type=script&lang=js&"
export * from "./bundle_package.vue?vue&type=script&lang=js&"
import style0 from "./bundle_package.vue?vue&type=style&index=0&id=7ed9fd24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed9fd24",
  null
  
)

export default component.exports